import { Bell, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MobileMenuButton } from "./responsive-sidebar";
import { useLanguage } from "@/hooks/use-language";

interface HeaderProps {
  onMobileMenuClick: () => void;
}

export default function Header({ onMobileMenuClick }: HeaderProps) {
  const { language, dir, toggleLanguage } = useLanguage();
  const isAr = language === "ar";

  return (
    <header dir={dir} className="relative z-10 shrink-0 flex items-center justify-between h-16 bg-white/90 backdrop-blur border-b-2 border-mint px-4 sm:px-6">
      <div className="flex items-center gap-3">
        <MobileMenuButton onClick={onMobileMenuClick} />
      </div>
      
      <div className="flex items-center gap-2.5">
        {/* Language Switcher */}
        <Button
          variant="outline"
          size="sm"
          onClick={toggleLanguage}
          className="h-8 px-3 rounded-xl border-slate-200 text-xs font-bold text-slate-700 hover:bg-slate-50 hover:text-slate-950 flex items-center gap-1.5 shadow-2xs transition-all"
          data-testid="language-switcher-button"
        >
          <Globe className="h-3.5 w-3.5 text-mint" />
          <span>{isAr ? "English" : "العربية"}</span>
        </Button>

        <Button
          variant="ghost"
          size="icon"
          className="h-9 w-9 text-slate-500 hover:text-slate-900 hover:bg-slate-100 rounded-xl"
          data-testid="notifications-button"
        >
          <Bell className="h-4 w-4" />
        </Button>
      </div>
    </header>
  );
}
